<template lang="pug" src="./SimpleCategoryProducts/template.pug"></template>

<script>
import SimpleCategoryProducts from './SimpleCategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'SimpleProductList',
    extends: SimpleCategoryProducts,
    methods: {
        refetch() {
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            let products = [];

            let ids = [];
            if ((products = get(this.section, 'products'))) {
                ids = products.map(product => product.id);
            }

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: this.perPage
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'ids',
                        in: ids
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'date' // property:groupsort
            };
            this.fetchProducts(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        }
    }
};
</script>
